(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["overseas-fast-delivery"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (root) => {
      if (root.dataset.overseasFastDeliveryReady === 'true') return;

      const skuData = root.querySelector('[data-overseas-fast-delivery-skus]');
      const variantData = root.querySelector('[data-overseas-fast-delivery-variants]');
      if (!skuData || !variantData) return;

      const eligibleSkus = new Set(JSON.parse(skuData.textContent));
      const variants = JSON.parse(variantData.textContent);
      const scope = root.closest('.shopify-section') || document;
      const productForm = scope.querySelector('form[action*="/cart/add"]');
      const variantInput = productForm?.querySelector('[name="id"]');

      const setVisibility = (visible) => {
        const update = () => {
          root.hidden = !visible;
          root.setAttribute('aria-hidden', String(!visible));
        };

        if (document.startViewTransition && root.hidden === visible) {
          document.startViewTransition(update);
        } else {
          update();
        }
      };

      const updateFromVariantId = (variantId) => {
        const variant = variants.find((item) => String(item.id) === String(variantId));
        const sku = String(variant?.sku || '').trim();
        setVisibility(Boolean(sku) && eligibleSkus.has(sku));
      };

      const update = () => {
        const urlVariantId = new URLSearchParams(window.location.search).get('variant');
        updateFromVariantId(variantInput?.value || urlVariantId);
      };

      const scheduleUpdate = () => {
        window.requestAnimationFrame(() => window.setTimeout(update, 0));
      };

      productForm?.addEventListener('change', scheduleUpdate);
      document.addEventListener('variant:change', (event) => {
        const variantId = event.detail?.variant?.id;
        if (variantId) {
          updateFromVariantId(variantId);
        } else {
          scheduleUpdate();
        }
      });
      window.addEventListener('popstate', scheduleUpdate);

      root.dataset.overseasFastDeliveryReady = 'true';
      update();
    };

    const initializeAll = (container = document) => {
      container.querySelectorAll('[data-overseas-fast-delivery]').forEach(initialize);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
